'use client';
import { jsx } from 'react/jsx-runtime';
import '../Popover/index.js';
import { PopoverTriggerContext } from '../Popover/PopoverTriggerContext.js';

/**
 * DropdownTriggerContext enables use of the `.Trigger` for the Dropdown component.
 *
 * @example
 * <Dropdown.TriggerContext>
 *  <Dropdown.Trigger>Dropdown</Dropdown.Trigger>
 *  <Dropdown>
 *   <Dropdown.Heading>Heading</Dropdown.Heading>
 *    <Dropdown.List>
 *      <Dropdown.Item>
 *        <Dropdown.Button>Button</Dropdown.Button>
 *      </Dropdown.Item>
 *    </Dropdown.List>
 *  </Dropdown>
 * </Dropdown.TriggerContext>
 */
const DropdownTriggerContext = ({ children, }) => {
    return jsx(PopoverTriggerContext, { children: children });
};
DropdownTriggerContext.displayName = 'DropdownTriggerContext';

export { DropdownTriggerContext };
